<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="toc_h"><span class="right_1" epub:type="pagebreak" id="page_v" title="v"><b>CONTENTS</b></span></p>
<p class="toc_fm1" id="rsec1"><a href="#/text/9780253063779_Preface#sec1"><i>Preface / Michael Dylan Foster</i></a></p>
<p class="toc_ch" id="rsec2"><a href="#/text/9780253063779_Chapter01#sec2">1<span class="sptoc">Introduction: We Are All Survivors / Carl Lindahl</span></a></p>
<p class="toc_ch" id="rsec3"><span href="#/text/9780253063779_Chapter02#sec3" title="Link target outside of Sample">2<span class="sptoc">Into the Bullring: The Significance of “Empathy” after the Earthquake / Yutaka Suga</span></span></p>
<p class="toc_ch" id="rsec4"><span href="#/text/9780253063779_Chapter03#sec4" title="Link target outside of Sample">3<span class="sptoc">Rebuilding and Reconnecting after Disaster: Listening to Older Adults / Yoko Taniguchi</span></span></p>
<p class="toc_ch" id="rsec5"><span href="#/text/9780253063779_Chapter04#sec5" title="Link target outside of Sample">4<span class="sptoc">The Story of Cultural Assets and Their Rescue: A Firsthand Report from Tohoku / Kōji Katō</span></span></p>
<p class="toc_ch" id="rsec6"><span href="#/text/9780253063779_Chapter05#sec6" title="Link target outside of Sample">5<span class="sptoc">Critical Empathy: A Survivor’s Study of Disaster / Kate Parker Horigan</span></span></p>
<p class="toc_ch" id="rsec7"><span href="#/text/9780253063779_Chapter06#sec7" title="Link target outside of Sample">6<span class="sptoc">Empathy and Speaking Out / Amy Shuman</span></span></p>
<p class="toc_ch" id="rsec8"><span href="#/text/9780253063779_Chapter07#sec8" title="Link target outside of Sample">7<span class="sptoc">The Intangible Lightness of Heritage / Michael Dylan Foster</span></span></p>
<p class="toc_ch" id="rsec9"><span href="#/text/9780253063779_Chapter08#sec9" title="Link target outside of Sample">8<span class="sptoc">Documenting Disaster Folklore in the Eye of the Storm: Six Months after María / Gloria M. Colom Braña</span></span></p>
<p class="toc_fm" id="rsec10"><span href="#/text/9780253063779_Conclusion#sec10" title="Link target outside of Sample">Conclusion: The COVID-19 Pandemic and “Folklife’s First Responders” / Georgia Ellie Dassler, with Kate Parker Horigan</span></p>
<p class="toc_fm" id="rsec11"><span href="#/text/9780253063779_Index#sec11" title="Link target outside of Sample"><i>Index</i></span><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253063779_Contents.vue?13d5cf96